import React, { useState } from "react";
import Button from "components/CustomButtons/Button.js";
import {
  CloudUpload,
  Delete,
  Edit,
  LinkSharp,
  PlayArrow,
  SyncAltSharp,
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { ethers } from "ethers";
import { stakingService } from "../../services/stakingService";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import { isAddress } from "ethers/lib/utils.js";
import { deploySoft } from "./soft-staking";

const STAKING_LINK = process.env.REACT_APP_STAKING_LINK;
const QUERY = `chain=${process.env.REACT_APP_NETWORK}`.toLowerCase();

export default function ActionSoft({ item, onCallNetwork, refresh }) {
  const [isModalDel, setIsModalDel] = useState(false);

  async function handleDelete() {
    if (!confirm("Delete staking ?")) return;
    await stakingService.remove(item._id);
    refresh();
  }

  function runDeploy() {
    const stakingChainId = item.chainId;
    localStorage.setItem("rowChainIdTemp", stakingChainId);
    onCallNetwork(
      "Deploy staking pool",
      async (signer) => {
        const collection = item.collections[0];
        console.log(collection, "cl");

        if (!ethers.utils.isAddress(item.rewardCoin)) {
          alert("Reward coin not available");
          return {};
        }

        if (!isAddress(collection.address)) {
          alert("Invalid collection address");
          return {};
        }

        return deploySoft(signer, {
          coinAddress: item.rewardCoin,
          collection: collection.address,
        });
      },
      async (data) => {
        return stakingService.update(item._id, {
          address: data.address,
        });
      }
    );
  }

  function runStart() {
    stakingService
      .update(item._id, {
        startTime: Math.floor(Date.now() / 1000),
      })
      .then(() => {
        refresh();
      });
  }

  function runSync() {
    stakingService.updateAvaiableReward(item._id, item.chainId).then(() => {
      refresh();
    });
  }

  return (
    <>
      <div className="actions-right">
        <Link to={`/admin/staking/${item._id}/${item.type}`}>
          <Button justIcon round simple color="primary" className="edit">
            <Edit />
          </Button>
        </Link>

        {["not_deployed"].includes(item.status) && (
          <Button
            justIcon
            round
            simple
            color="success"
            onClick={() => runDeploy()}
          >
            <CloudUpload />
          </Button>
        )}

        {["not_started", "finished"].includes(item.status) && (
          <Button
            justIcon
            round
            simple
            color="success"
            onClick={() => runStart()}
          >
            <PlayArrow />
          </Button>
        )}

        {!["not_deployed"].includes(item.status) && (
          <Button
            justIcon
            round
            simple
            color="success"
            onClick={() => runSync()}
          >
            <SyncAltSharp />
          </Button>
        )}

        <a
          href={`${STAKING_LINK}/pools/soft/${item._id}/stakingPools?${QUERY}`}
          target="_blank"
          rel="noreferrer"
        >
          <Button justIcon round simple color="success" className="edit">
            <LinkSharp />
          </Button>
        </a>

        <Button
          justIcon
          round
          simple
          color="danger"
          onClick={() => {
            handleDelete(item._id);
          }}
        >
          <Delete />
        </Button>
      </div>

      <Dialog
        open={isModalDel}
        onClose={() => setIsModalDel(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm remove staking"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => setIsModalDel(false)} color="transparent">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(item?._id);
            }}
            color="success"
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

ActionSoft.propTypes = {
  item: PropTypes.any,
  onCallNetwork: PropTypes.func,
  refresh: PropTypes.func,
};
